<template>
  <window :winVisible="imShowChatInfoVisible" :modal-append-to-body="false" width="230px" height="100%" margin="auto 0 auto auto" modal="modal-slide-left" :wrapperClosable="true" @wrapperClick="wrapperClick">
    <team-info v-if="imActiveAccount.scene === 'team'" :team="team" />
    <account-info v-else :account="account" />
  </window>
</template>

<script>
import { mapState } from 'vuex'
import Window from '../../Window'
import TeamInfo from '../../team/TeamInfo'
import AccountInfo from './AccountInfo'
export default {
  name: 'ShowChatInfo',
  components: { TeamInfo, AccountInfo, Window },
  computed: {
    ...mapState({
      imShowChatInfoVisible: state => state.imShowChatInfoVisible,
      imActiveAccount: state => state.imActiveAccount,
      imTeams: state => state.imTeams,
      imQyhContactData: state => state.imQyhContactData,
      imUserProfiles: state => state.imUserProfiles
    }),
    team () {
      return this.imTeams[this.imActiveAccount.to]
    },
    account () {
      let acc = this.imQyhContactData.find(item => item.im_accid === this.imActiveAccount.to)
      if (!acc) {
        acc = this.imUserProfiles[this.imActiveAccount.to]
      }
      return acc
    }
  },
  data () {
    return {
    }
  },
  methods: {
    wrapperClick () {
      if (this.imShowChatInfoVisible) this.$store.dispatch('changeImShowChatInfoVisibleAction', false)
    }
  }
}
</script>

<style lang="stylus" scoped>
.im-right-content-height-more {
  cursor: pointer;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/common/im/right/chat/ShowChatInfo.vue